module.exports = __webpack_public_path__ + "img/extended.f48fca4a.png";